// SubTaskItem.jsx
import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CompletedSVG from '../../assets/Completed';
import EditSVG from '../../assets/Edit';
import config from '../../utils/config';
import LatestUpload from './LatestUpload';
import { useAuth } from '../../utils/AuthContext/AuthContext';
import { useMediaQuery } from 'react-responsive';
import AISVG from '../../assets/AI';

const SubTaskItem = ({ 
  number, 
  title, 
  actionTexts, 
  subText, 
  onToggle, 
  isCompleted, 
  decision, 
  isSchedule, 
  scheduleDate, 
  onScheduleChange, 
  onAction, 
  stepType
}) => {
  const navigate = useNavigate();
  const [isEditing, setIsEditing] = useState(false);
  const [localDate, setLocalDate] = useState(scheduleDate || '');
  const userString = localStorage.getItem('user');
  const userObject = userString ? JSON.parse(userString) : null;
  const userId = userObject?.id || userObject?._id;
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

  const handleActionClick = (text) => {
    // if (text === 'Schedule') {
    //   navigate('/professionals', { state: { selectedProfession: 'Inspector' } });
    // } else 
    if (text === 'Complete') {
        if (onToggle) {
          onToggle();
        }
    } else {
      console.log(`click`);
    }
  };

  const handleClick = (text) => {
    if (text === 'Schedule' && number === '3.2') {
      // Navigate to professionals page for scheduling, if needed.
      navigate('/professionals', { state: { selectedProfession: 'Inspector' } });
    } else if (text === 'Contact' && number === '5.1') {
        navigate('/professionals', { state: { selectedProfession: 'Insurance' } });   
    } else if (text === 'Complete') {
      if (onToggle) {
        onToggle();
      }
    } else {
        console.log(`click`);
    }
  };

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleDateChange = (e) => {
    const newDate = e.target.value;
    setLocalDate(newDate);
  };

  const handleBlur = () => {
    // Only update the parent state when user leaves the input.
    onScheduleChange(localDate);
    setIsEditing(false);
  };

  return (
    <div className="flex flex-col">
      <div className="flex justify-between w-full items-center py-1 md:py-4 gap-2 md:pl-10">
        <div className="flex flex-col w-full">
          <div className="flex items-center text-base text-black">
            <span className="mr-1 md:mr-2 font-normal text-[11px] md:text-[14px]">{number}</span>
            <span className="text-[11px] md:text-[14px] pr-2 text-shi-green font-medium">{title}</span>
          </div>
          <div className="text-[11px] md:text-[14px] text-gray-600 mt-1 md:max-w-[500px] max-w-[45vw] md:pl-7">{subText}</div>
        </div>
        <div className="flex flex-col gap-2 items-end ml-2">
          {actionTexts &&
            actionTexts.map((text, idx) => {
              if (text === 'Complete') {
                return (
                  <button
                    key={idx}
                    className={`flex items-center text-[11px] md:text-[12px] md:px-2 md:py-1 p-[4px] rounded-md border border-solid ${
                      isCompleted
                        ? 'bg-shi-green text-white'
                        : 'bg-neutral-100 text-shi-green'
                    } hover:bg-slate-700 hover:text-white`}
                    onClick={() => handleActionClick('Complete')}
                  >
                    {isCompleted ? (
                      <span className="inline-flex items-center w-auto">
                        <CompletedSVG width={20} height={20} />
                        <p className='ml-1'>Completed</p>
                      </span>
                    ) : (
                      'Complete'
                    )}
                  </button>
                );
              }
              else if (text === 'Schedule' && number === '3.2') {
                return (
                  <button
                    key={idx}
                    className={`text-[11px] md:text-[12px] md:px-2 md:py-1 p-[4px] rounded-md border border-solid ${
                      isCompleted
                        ? 'bg-shi-green text-white'
                        : 'bg-neutral-100 text-shi-green'
                    } hover:bg-slate-700 hover:text-white`}
                    onClick={() => handleClick('Schedule')}
                  >
                    {isCompleted ? 'Scheduled' : 'Schedule'}
                  </button>
                );
              }
              else if (text === 'Upload' && (stepType === 'inspection' || stepType === 'title' )) {
                return (
                    <React.Fragment key={idx}>
                    <button
                        key={idx}
                        onClick={() => onAction && onAction(text)}
                        className={`flex items-center text-[11px] md:text-[12px] md:px-2 md:py-1 p-[4px] rounded-md border border-slate-200 ${
                            isCompleted
                            ? 'bg-shi-green border-shi-green text-white'
                            : 'bg-neutral-100 border-shi-green text-shi-green hover:bg-slate-700 hover:text-white'
                        }`}
                    >
                    {isCompleted ?  <span className="inline-flex items-center w-auto"><CompletedSVG width={20} height={20} /><p className='ml-1'>Completed</p></span> : 'Upload'}
                    </button>
                {/* {isCompleted && (
                <LatestUpload formType="inspection"/>
                )} */}
                    </React.Fragment>
                )
            }
            // In SubTaskItem.jsx, inside your actionTexts.map callback:
            else if (text === 'Analyze' && (stepType === 'inspection' || stepType === 'title')) {
                return (
                  <div className='inline-flex gap-2' key={idx}>
                    <button
                      onClick={() => onAction && onAction('Analyze')}
                      className={`flex items-center text-[11px] md:text-[12px] py-1 px-2 w-auto rounded-md border border-slate-200 ${
                        isCompleted
                          ? 'bg-shi-green border-shi-green text-white'
                          : 'bg-neutral-100 border-shi-green text-shi-green hover:bg-slate-700 hover:text-white'
                      }`}
                    >
                      {isCompleted ? (
                        <span className="inline-flex items-center w-auto">
                          <CompletedSVG width={20} height={20} />
                          <p className="ml-1">Completed</p>
                        </span>
                      ) : (
                        <>
                          <AISVG width={30} height={22} />
                          <span className='ml-1'>Analyze</span>
                        </>
                      )}
                    </button>
                  </div>
                );
              } 
            else if (text === 'Generate' && number === '3.5') {
                return (
                <button
                key={idx}
                onClick={() => onAction && onAction(text)}
                className={`flex items-center text-[11px] md:text-[12px] md:px-2 md:py-1 p-[4px] rounded-md border border-slate-200 ${
                  isCompleted
                    ? 'bg-shi-green border-shi-green text-white'
                    : 'bg-neutral-100 border-shi-green text-shi-green hover:bg-slate-700 hover:text-white'
                }`}
                >
                {isCompleted ? <span className="inline-flex items-center w-auto"><CompletedSVG width={20} height={20} /><p className='ml-1'>Completed</p></span> : 'Generate'}
                </button>
                )
            }
            else if (text === 'Withdraw' && number === '3.7') {
                return (
                <button
                key={idx}
                onClick={() => onAction && onAction(text)}
                className={`flex items-center text-[11px] md:text-[12px] md:px-2 md:py-1 p-[4px] rounded-md border border-slate-200 ${
                  isCompleted && decision === "Withdraw"
                    ? 'bg-shi-green border-shi-green text-white'
                    : 'bg-neutral-100 border-shi-green text-shi-green hover:bg-slate-700 hover:text-white'
                }`}
                >
                {isCompleted && decision === "Withdraw" ? <span className="inline-flex items-center w-auto"><CompletedSVG width={20} height={20} /><p className='ml-1'>Withdraw</p></span> : 'Withdraw'}
                </button>
                )
            }
            else if (text === 'Resolve' && number === '3.7') {
                return (
                <button
                    key={idx}
                    onClick={() => {
                        onAction && onAction(text)
                    }}
                    className={`flex items-center text-[11px] md:text-[12px] md:px-2 md:py-1 p-[4px] rounded-md border border-slate-200 ${
                    isCompleted && decision === "Resolution"
                        ? 'bg-shi-green border-shi-green text-white'
                        : 'bg-neutral-100 border-shi-green text-shi-green hover:bg-slate-700 hover:text-white'
                    }`}
                    >
                    {isCompleted && decision === "Resolution" ? <span className="inline-flex items-center w-auto"><CompletedSVG width={20} height={20} /><p className='ml-1'>Resolve</p></span> : 'Resolve'}
                </button>
                )
            }
            else if (text === 'Generate' && number === '4.5') {
                return (
                <button
                key={idx}
                onClick={() => onAction && onAction(text)}
                className={`flex items-center text-[11px] md:text-[12px] md:px-2 md:py-1 p-[4px] rounded-md border border-slate-200 ${
                  isCompleted
                    ? 'bg-shi-green border-shi-green text-white'
                    : 'bg-neutral-100 border-shi-green text-shi-green hover:bg-slate-700 hover:text-white'
                }`}
                >
                {isCompleted ? <span className="inline-flex items-center w-auto"><CompletedSVG width={20} height={20} /><p className='ml-1'>Completed</p></span> : 'Generate'}
                </button>
                )
            }
            else if (text === 'Withdraw' && number === '4.6') {
                return (
                <button
                key={idx}
                onClick={() => onAction && onAction(text)}
                className={`flex items-center text-[11px] md:text-[12px] md:px-2 md:py-1 p-[4px] rounded-md border border-slate-200 ${
                  isCompleted && decision === "Withdraw"
                    ? 'bg-shi-green border-shi-green text-white'
                    : 'bg-neutral-100 border-shi-green text-shi-green hover:bg-slate-700 hover:text-white'
                }`}
                >
                {isCompleted && decision === "Withdraw" ? <span className="inline-flex items-center w-auto"><CompletedSVG width={20} height={20} /><p className='ml-1'>Withdraw</p></span> : 'Withdraw'}
                </button>
                )
            }
            else if (text === 'Schedule' && number === '6.2') {
                return (
                  <button
                    key={idx}
                    className={`text-[11px] md:text-[12px] md:px-2 md:py-1 p-[4px] rounded-md border border-solid ${
                      isCompleted
                        ? 'bg-shi-green text-white'
                        : 'bg-neutral-100 text-shi-green'
                    } hover:bg-slate-700 hover:text-white`}
                    onClick={() => handleClick('Schedule')}
                  >
                    {isCompleted ? 'Scheduled' : 'Schedule'}
                  </button>
                );
              }
            else if (text === 'Generate' && number === '6.3') {
                return (
                <button
                key={idx}
                onClick={() => onAction && onAction(text)}
                className={`flex items-center text-[11px] md:text-[12px] md:px-2 md:py-1 p-[4px] rounded-md border border-slate-200 ${
                  isCompleted
                    ? 'bg-shi-green border-shi-green text-white'
                    : 'bg-neutral-100 border-shi-green text-shi-green hover:bg-slate-700 hover:text-white'
                }`}
                >
                {isCompleted ? <span className="inline-flex items-center w-auto"><CompletedSVG width={20} height={20} /><p className='ml-1'>Completed</p></span> : 'Generate'}
                </button>
                )
            }
            else if (text === 'Withdraw' && number === '6.4') {
                return (
                <button
                key={idx}
                onClick={() => onAction && onAction(text)}
                className={`flex items-center text-[11px] md:text-[12px] md:px-2 md:py-1 p-[4px] rounded-md border border-slate-200 ${
                  isCompleted && decision === "Withdraw"
                    ? 'bg-shi-green border-shi-green text-white'
                    : 'bg-neutral-100 border-shi-green text-shi-green hover:bg-slate-700 hover:text-white'
                }`}
                >
                {isCompleted && decision === "Withdraw" ? <span className="inline-flex items-center w-auto"><CompletedSVG width={20} height={20} /><p className='ml-1'>Withdraw</p></span> : 'Withdraw'}
                </button>
                )
            }
            else if (text === 'Schedule' && number === '8.1') {
                return (
                  <button
                    key={idx}
                    className={`text-[11px] md:text-[12px] md:px-2 md:py-1 p-[4px] rounded-md border border-solid ${
                      isCompleted
                        ? 'bg-shi-green text-white'
                        : 'bg-neutral-100 text-shi-green'
                    } hover:bg-slate-700 hover:text-white`}
                    onClick={() => handleClick('Schedule')}
                  >
                    {isCompleted ? 'Scheduled' : 'Schedule'}
                  </button>
                );
              }
              else if (text === 'Schedule' && number === '9.1') {
                return (
                  <button
                    key={idx}
                    className={`text-[11px] md:text-[12px] md:px-2 md:py-1 p-[4px] rounded-md border border-solid ${
                      isCompleted
                        ? 'bg-shi-green text-white'
                        : 'bg-neutral-100 text-shi-green'
                    } hover:bg-slate-700 hover:text-white`}
                    onClick={() => handleClick('Schedule')}
                  >
                    {isCompleted ? 'Scheduled' : 'Schedule'}
                  </button>
                );
              }
            else if (text === 'Terminate' && (stepType === 'inspection' || stepType === 'title' || stepType === 'appraisal')) {
                return (
                <button
                    key={idx}
                    onClick={() => {
                        onAction && onAction(text)
                    }}
                    className={`flex items-center text-[11px] md:text-[12px] md:px-2 md:py-1 p-[4px] rounded-md border border-slate-200 ${
                    isCompleted && decision === "Termination"
                        ? 'bg-shi-green border-shi-green text-white'
                        : 'bg-neutral-100 border-shi-green text-shi-green hover:bg-slate-700 hover:text-white'
                    }`}
                    >
                    {isCompleted && decision === "Termination" ? <span className="inline-flex items-center w-auto"><CompletedSVG width={20} height={20} /><p className='ml-1'>Terminate</p></span> : 'Terminate'}
                </button>
                )
            }
              else {
                return (
                  <button
                    key={idx}
                    className="text-[11px] md:text-[12px] md:px-2 md:py-1 p-[4px] rounded-md border border-solid bg-neutral-100 text-shi-green hover:bg-slate-700 hover:text-white"
                    onClick={() => handleClick(text)}
                  >
                    {text}
                  </button>
                );
              }
            })}
        </div>
      </div>
      {/* For scheduleInspector sub-step: */}
      {isCompleted && number === '3.2' && (
  <div className="flex pl-10 pr-2 w-full justify-end items-center">
    {(!scheduleDate || isEditing) ? (
      <div className="flex items-center gap-2">
        <label className="text-[12px] text-gray-600">Schedule:</label>
        <input
          type="date"
          className="border p-2 rounded w-auto h-8 text-sm"
          onChange={handleDateChange}
          onBlur={handleBlur}
          autoFocus={false}
        />
      </div>
    ) : (
      <div className="inline-flex items-center gap-2 text-shi-green">
        <div className='md:inline-flex flex flex-col'>
            <span className='text-[12px]'>Scheduled:</span>
            <span className='text-[12px]'>{scheduleDate}</span>
        </div>
        <button onClick={handleEditClick} aria-label="Edit Schedule Date">
          <EditSVG width={18} height={18} />
        </button>
      </div>
    )}
  </div>
)}
{/* Appraisal Step */}
{isCompleted && number === '6.2' && (
  <div className="flex pl-10 pr-2 w-full justify-end items-center">
    {(!scheduleDate || isEditing) ? (
      <div className="flex items-center gap-2">
        <label className="text-[12px] text-gray-600">Schedule:</label>
        <input
          type="date"
          className="border p-2 rounded w-auto h-8 text-sm"
          onChange={handleDateChange}
          onBlur={handleBlur}
          autoFocus={false}
        />
      </div>
    ) : (
      <div className="inline-flex items-center gap-2 text-shi-green">
        <div className='md:inline-flex flex flex-col'>
            <span className='text-[12px]'>Scheduled:</span>
            <span className='text-[12px]'>{scheduleDate}</span>
        </div>
        <button onClick={handleEditClick} aria-label="Edit Schedule Date">
          <EditSVG width={18} height={18} />
        </button>
      </div>
    )}
  </div>
)}
{/* Closing Day Step */}
{isCompleted && number === '8.1' && (
  <div className="flex pl-10 pr-2 w-full justify-end items-center">
    {(!scheduleDate || isEditing) ? (
      <div className="flex items-center gap-2">
        <label className="text-[12px] text-gray-600">Schedule:</label>
        <input
          type="date"
          className="border p-2 rounded w-auto h-8 text-sm"
          onChange={handleDateChange}
          onBlur={handleBlur}
          autoFocus={false}
        />
      </div>
    ) : (
      <div className="inline-flex items-center gap-2 text-shi-green">
        <div className='md:inline-flex flex flex-col'>
            <span className='text-[12px]'>Scheduled:</span>
            <span className='text-[12px]'>{scheduleDate}</span>
        </div>
        <button onClick={handleEditClick} aria-label="Edit Schedule Date">
          <EditSVG width={18} height={18} />
        </button>
      </div>
    )}
  </div>
)}
{/* Walkthrough Step */}
{isCompleted && number === '9.1' && (
  <div className="flex pl-10 pr-2 w-full justify-end items-center">
    {(!scheduleDate || isEditing) ? (
      <div className="flex items-center gap-2">
        <label className="text-[12px] text-gray-600">Schedule:</label>
        <input
          type="date"
          className="border p-2 rounded w-auto h-8 text-sm"
          onChange={handleDateChange}
          onBlur={handleBlur}
          autoFocus={false}
        />
      </div>
    ) : (
      <div className="inline-flex items-center gap-2 text-shi-green">
        <div className='md:inline-flex flex flex-col'>
            <span className='text-[12px]'>Scheduled:</span>
            <span className='text-[12px]'>{scheduleDate}</span>
        </div>
        <button onClick={handleEditClick} aria-label="Edit Schedule Date">
          <EditSVG width={18} height={18} />
        </button>
      </div>
    )}
  </div>
)}

    </div>
  );
}

export default SubTaskItem;